import { chainConfigs, ChainId } from 'bzx-common/src/config/appConfig'
import { IAirdropInfo } from 'bzx-common/src/services/AirdropService'
import { observer } from 'mobx-react'
import React, { CSSProperties } from 'react'
import ButtonChainSwitch from 'shared-components/ButtonChainSwitch'
import { Button, Input } from 'ui-framework'
import CompensationClaim from '../CompensationClaim'
import CompensationVM from '../CompensationVM'
import ApprovalCheck from './ApprovalCheck'

const styles: Record<string, CSSProperties> = {
  inputWrapper: { maxWidth: '500px' },
}

/**
 * Used to claim BZRX for people who lost BZRX in hack or had BZRX stuck on BSC
 */
export function BZRXCommonCompensation({
  vm,
  compensations,
  chainIdNeeded,
}: {
  vm: CompensationVM
  compensations: IAirdropInfo[]
  chainIdNeeded: ChainId
}) {
  const { chainId, isConnected } = vm.rootStore.web3Connection
  const entitledCompensations = compensations.filter((airdrop) => airdrop.amount.gt(0))
  const isEntitledToCompensation = entitledCompensations.length > 0
  const hasClaimableCompensations = entitledCompensations.some((claim) => !claim.userClaimed)
  const compensationListVisible = !hasClaimableCompensations || vm.approvalsChecked
  const needToConnectRightWallet =
    isConnected && hasClaimableCompensations && !vm.inputAddressEqualConnected && vm.inputAddress

  if (chainId !== chainIdNeeded) {
    return (
      <div className="flex-center">
        <ButtonChainSwitch chainId={chainIdNeeded}>
          Switch to {chainConfigs[chainIdNeeded].chainDetails.shortName}
        </ButtonChainSwitch>
      </div>
    )
  }

  return (
    <div>
      <form onSubmit={vm.checkAirdrop} className="margin-bottom-2">
        <label className="txt-subtitle margin-bottom-05" htmlFor="input-wallet-address">
          Wallet Address
        </label>
        <div className="input-with-sticked-btn" style={styles.inputWrapper}>
          <Input
            id="input-wallet-address"
            onChange={vm.set}
            onChangeEmit="name-value"
            name="inputAddress"
            value={vm.inputAddress}
          />
          <Button
            variant="green"
            disabled={!vm.canCheck}
            type="submit"
            isLoading={vm.airdropStore.airdropInfoPending}>
            Check
          </Button>
        </div>
      </form>

      {vm.airdropStore.airdropsInfoLoaded && (
        <>
          {!isConnected && hasClaimableCompensations && (
            <p className="txt-warning">You need to connect your wallet to claim.</p>
          )}

          {hasClaimableCompensations && !vm.isBadBoy && (
            <div className="margin-bottom-2">
              <ApprovalCheck vm={vm} />
            </div>
          )}

          {compensationListVisible && (
            <>
              <h4>Claims</h4>

              {!isEntitledToCompensation && (
                <p className="txt-warning">No compensation was found for this address.</p>
              )}

              {needToConnectRightWallet && (
                <p className="txt-warning">
                  To claim, you need to connect with the same wallet that you are checking.
                </p>
              )}

              {entitledCompensations.map((compensation) => (
                <CompensationClaim
                  key={`${compensation.airdrop}-${compensation.airdropIndex}`}
                  vm={vm}
                  compensation={compensation}
                />
              ))}
            </>
          )}
        </>
      )}
    </div>
  )
}

export default observer(BZRXCommonCompensation)
